import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const RED = "#e11d2a";

/**
 * AuthCallback — traite le retour du login Google géré par Emergent.
 * Le session_id arrive dans le fragment d'URL : /auth/callback#session_id=xxx
 */
export default function AuthCallback() {
  const { loginWithGoogleSession } = useAuth();
  const nav = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      nav("/connexion", { replace: true });
      return;
    }
    (async () => {
      try {
        const user = await loginWithGoogleSession(sessionId);
        // nettoyer le fragment
        window.history.replaceState(null, "", window.location.pathname);
        nav(user && !user.profile_completed ? "/profil" : "/hub", { replace: true });
      } catch (e) {
        window.history.replaceState(null, "", window.location.pathname);
        if (e?.response?.status === 402) {
          setError("Abonnement requis. Redirection vers l'abonnement…");
          setTimeout(() => nav("/inscription", { replace: true }), 1600);
        } else {
          setError("Échec de la connexion Google. Réessaie.");
          setTimeout(() => nav("/connexion", { replace: true }), 1800);
        }
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div style={styles.page}>
      <div style={styles.kanji}>天</div>
      {error ? (
        <p style={styles.err}>{error}</p>
      ) : (
        <>
          <div style={styles.spinner} />
          <p style={styles.text}>Ouverture des portes du dōjō…</p>
        </>
      )}
    </div>
  );
}

const styles = {
  page: { minHeight: "100vh", background: "#fff", color: "#111", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 18, fontFamily: "'Inter', system-ui, sans-serif" },
  kanji: { fontSize: 56, fontWeight: 700, color: RED },
  spinner: { width: 34, height: 34, borderRadius: "50%", border: `3px solid #eee`, borderTopColor: RED, animation: "td-spin 0.8s linear infinite" },
  text: { color: "#666", fontSize: 14 },
  err: { color: RED, fontSize: 14, fontWeight: 600 },
};

// keyframes injectées une fois
if (typeof document !== "undefined" && !document.getElementById("td-spin-kf")) {
  const s = document.createElement("style");
  s.id = "td-spin-kf";
  s.textContent = "@keyframes td-spin{to{transform:rotate(360deg)}}";
  document.head.appendChild(s);
}
